<template>
  <v-menu
    :ref="`menuDate${name}`"
    v-model.trim="view.elem.menu.date"
    :close-on-content-click="false"
    :return-value.sync="view.elem.date.value"
    transition="scale-transition"
    offset-y
    left
    min-width="auto"
    class="datemenu"
    style="width: 100%">
    <template #activator="{ on, attrs }">
      <v-text-field
        :ref="`date${name}`"
        v-model.trim="view.elem.date.date"
        v-mask="maskcomputed"
        :error-messages="errormessages"
        :label="label"
        :disabled="disabled"
        :dense="dense"
        :prepend-icon="prependicon"
        :append-icon="appendicon"
        :class="clase"
        clearable
        v-bind="attrs"
        @click:append="on.click"
        @click:clear="clearDate"
        @change="changeDate" />
    </template>
    <v-date-picker
      v-model="dateFormatted"
      :locale="$t('view.commons.locale')"
      :min="min"
      :max="max"
      :disabled="disabled"
      :type="type"
      show-current
      no-title
      scrollable
      @change="changeDate"
      @input="$refs[`menuDate${name}`].save(dateFormatted)">
      <v-btn
        v-if="enableToday"
        text
        color="primary"
        style="width: 100%"
        @click="
          $refs[`menuDate${name}`].save((dateFormatted = setToday()));
          changeDate();
        "
        >{{ $t("view.commons.today") }}</v-btn
      >
    </v-date-picker>
  </v-menu>
</template>
<script>
import { formatToISO, setToday, setPeriod } from "@/helpers/date-methods";

export default {
  name: "DatePicker"
  , props: {
    name: {
      default: ""
      , type: String
    }
    , label: {
      default: ""
      , type: String
    }
    , value: {
      default: ""
      , type: String
    }
    , type: {
      default: "date"
      , type: String
    }
    , disabled: {
      default: false
      , type: Boolean
    }
    , min: {
      default: ""
      , type: String
    }
    , max: {
      default: ""
      , type: String
    }
    , enableToday: {
      default: true
      , type: Boolean
    }
    , errormessages: {
      default: ""
      , type: String
    }
    , clase: {
      default: ""
      , type: String
    }
    , prependicon: {
      default: ""
      , type: String
    }
    , appendicon: {
      default: "event"
      , type: String
    }
    , dense: {
      default: false
      , type: Boolean
    }
  }
  , data() {
    return {
      view: {
        elem: {
          menu: { date: false }
          , date: {
            value: ""
            , date: this.value
            , disabled: false
          }
        }
      }
    };
  }
  , computed: {
    dateFormatted: {
      get() {
        return formatToISO(this.view.elem.date.date);
      }
      , set(newValue) {
        this.view.elem.date.date = newValue;
      }
    }
    , maskcomputed() {
      return this.type == "date" ? "####-##-##" : "####-##";
    }
  }
  , methods: {
    changeDate(val = this.view.elem.date.date) {
      const strlength = this.type == "date" ? 10 : 7;
      if (val && val.length == strlength) {
        if (this.max && this.max != "" && (new Date(val) > new Date(this.max) || isNaN(new Date(val)))) {
          this.view.elem.date.date = this.max;
          val = this.max;
        }
        if (this.min && this.min != "" && (new Date(val) < new Date(this.min) || isNaN(new Date(val)))) {
          this.view.elem.date.date = this.min;
          val = this.min;
        }
        this.$emit("changeDate", this.name, val);
      }
      if (!val) this.$emit("changeDate", this.name, "");
    }
    , clearDate() {
      this.view.elem.date.date = "";
      this.$emit("changeDate", this.name, "");
    }
    , setToday() {
      return this.type == "date" ? setToday() : setPeriod();
    }
    , setDate(newDate) {
      this.view.elem.date.date = newDate;
    }
    , setPeriod
  }
};
</script>



// WEBPACK FOOTER //
// src/components/forms/DatePicker.vue